export const managementFeeConstants = {
  GET_ALL_REQUEST: "MANAGEMENT_FEE_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "MANAGEMENT_FEE_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "MANAGEMENT_FEE_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "MANAGEMENT_FEE_RESET_ALL_SUCCESS",

  EDIT_MANAGEMENT_FEE_REQUEST: "MANAGEMENT_FEE_EDIT_MANAGEMENT_FEE_REQUEST",
  EDIT_MANAGEMENT_FEE_SUCCESS: "MANAGEMENT_FEE_EDIT_MANAGEMENT_FEE_SUCCESS",
  EDIT_MANAGEMENT_FEE_FAILURE: "MANAGEMENT_FEE_EDIT_MANAGEMENT_FEE_FAILURE",
  RESET_EDIT_MANAGEMENT_FEE_SUCCESS: "MANAGEMENT_FEE_RESET_EDIT_MANAGEMENT_FEE_SUCCESS"
};
